import { render, staticRenderFns } from "./ManageGroups.vue?vue&type=template&id=e7425d7a"
import script from "./ManageGroups.vue?vue&type=script&lang=js"
export * from "./ManageGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports